"use client";

import { usePathname } from "next/navigation";
import { Header } from "@/components/header";
import { Footer } from "@/components/footer";
import { Breadcrumb } from "@/components/breadcrumb";
import { AssistantSlot } from "@/components/assistant-slot";

export function SiteChrome({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  if (pathname.startsWith("/admin")) {
    return (
      <>
        {children}
        <AssistantSlot />
      </>
    );
  }
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <Breadcrumb />
      <main className="flex-1">{children}</main>
      <Footer />
      <AssistantSlot />
    </div>
  );
}
